import React from 'react';

import {SubTitleLarge} from '@spaced-out/ui-design-system/lib/components/Text';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  Card,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import type {AlertSemanticType} from '@spaced-out/ui-design-system/lib/types/common';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';
import {classify} from '@spaced-out/ui-design-system/lib/utils/classify';

import css from './small-card.css';


interface SmallCardProps {
  title: string;
  icon: string;
  children: React.ReactNode;
  iconSemantic?: AlertSemanticType;
  testId?: string;
  classNames?: {
    wrapper?: string;
    content?: string;
  };
}

export const SmallCard = ({
  children,
  icon,
  title,
  iconSemantic = 'information',
  testId,
  classNames,
}: SmallCardProps) => {
  return (
    <Card
      classNames={{wrapper: classify(css.cardWrapper, classNames?.wrapper)}}
      testId={generateTestId({base: testId, slot: 'small-card'})}
    >
      <CardContent className={classify(css.cardContent, classNames?.content)}>
        <div className={css.cardHeader}>
          <SemanticIcon
            size="large"
            name={icon}
            type="solid"
            semantic={iconSemantic}
          />
          <SubTitleLarge>
            {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
            {title}
          </SubTitleLarge>
        </div>
        {/* Children are react components */}
        {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
        {children}
      </CardContent>
    </Card>
  );
};
